<div class="new-comment"
  [class.no-border]="noBorder"
  [class.is-disabled]="sending"
  [class.is_focused]="textareaFocused"
  [class.is_file_over]="isFileOver"
  [class.is-error]="isInvalid || charactersLengthErrorMessage"
  [class.has-info-icon]="infoTooltipTranslation"
  >
  @if (infoTooltipTranslation) {
    <div class="info" #info
      (pointerdown)="lastPointerType = $event.pointerType"
      (pointerenter)="onInfoPointerEnter($event)"
      (pointerleave)="onInfoPointerLeave($event)"
      (click)="onInfoClick()">
      <img class="info-icon" alt="Info" src="/assets/icons/new/info-2.svg">
      @if (infoPopupShown) {
        <div class="info-popup" [class.below]="infoPopupBelow">
          <div [fiTranslation]="infoTooltipTranslation" [hasHTMLTags]="true"></div>
        </div>
      }
    </div>
  }
  <textarea fiDragAndDrop
    (fileDropped)="onFileDropped($event)"
    #editor
    [fiTranslation]="placeholderTranslation"
    [isPLaceHolder]="true"
    (focus)="onTextareaFocus()"
    (focusout)="textareaFocused = false"
    (input)="onInput($event)"
    [disabled]="sending"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
  ></textarea>
  @if (!noUploads) {
    <div class="new-comment-footer">
      <div class="new-comment-footer-upload">
        <div class="action" (click)="fileInput.click()">
          <img alt="Upload" src="/assets/icons/upload.svg" #upload [isTitle] = "true" fiTranslation="ALT_TEXT_BUTTON_UPLOAD" matTooltip="{{upload.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
          <span class="hide-for-mobile">{{ uploadLabel }}</span>
        </div>
        @if (uploadHint) {
          <span class="upload-hint hide-for-mobile">{{ uploadHint }}</span>
        }
      </div>
      <div class="uploaded-items" [class.hide-send-button]="hideSendButton">
        @for (upload of uploads; track upload; let i = $index) {
          <div class="upload" [title]="upload.Name">
            <span class="name">{{ upload.Name }}</span><span class="close-icon" (click)="removeUpload(i)"></span>
          </div>
        }
      </div>
      @if (!hideSendButton) {
        <div class="action send" [class.active] = "(hasInputValue || imageUploaded) && !charactersLengthErrorMessage" (click)="createComment()"><span class="hide-for-mobile" fiTranslation="BUTTON_NOTE_SUBMIT"></span> <img alt="Send" src="/assets/icons/arrow-short.svg"></div>
      }
    </div>
  }
</div>
<input #fileInput type="file" multiple hidden (change)="onUpload($event)" accept="{{ accept }}">
<div class="charactersLengthErrorMessage" [class.is_hidden]="!charactersLengthErrorMessage" fiTranslation="CONTACT_ERRORMSG_NOTE_TEXT_TOO_LONG"></div>
